import api from "./axios";
import type { FeedbackFormType } from "@/struct/FeedbackStruct";

export const sendFeedback = async (data: FeedbackFormType) => {
  return await api.post("/api/web-api/rating/create", {
    msisdn: data.msisdn,
    rate_tariff: data.rate_tariff,
    rate_service: data.rate_service,
    rate_website: data.rate_website,
    comment: data.comment,
  });
};
